import React from 'react';
import { Card, CardGroup } from 'react-bootstrap';

const InformationCards = ({cardData}) => {
    return (
        <CardGroup>
            {cardData.map((card, index) => (
                <Card
                    bg={card.type.toLowerCase()}
                    key={index}
                    text={'white'}
                    style={{ width: '10rem', margin: '10px' }}
                    className="mb-2 position-static"
                >
                    <Card.Header> Subscriptions {card.type} in month </Card.Header>
                    <Card.Body>
                        <Card.Title> {card.count}  {card.label}  </Card.Title>
                        <Card.Text>
                            {card.text}
                        </Card.Text>
                    </Card.Body>
                </Card>
            ))}
        </CardGroup>
    );
};

export default InformationCards;